import type { ReactNode } from "react";
import LandingFooter from "@/components/landing/shared/LandingFooter";
import LandingHeader from "@/components/landing/shared/LandingHeader";
import type { MarketingNavKey } from "./MarketingHeader";
import "./marketing.css";

/**
 * Page shell for the public marketing and legal routes: the `.mk` scope root
 * (tokens, Geist, container queries), the sticky marketing header, <main> and
 * the marketing footer. There is no announcement banner and no reserved space
 * for one — the header sits at the top of the page.
 */
const MarketingLayout = ({ active, children }: { active?: MarketingNavKey; children: ReactNode }) => (
  <div className="mk" id="top">
    <LandingHeader appearance="marketing" active={active} />
    <main>{children}</main>
    <LandingFooter appearance="marketing" />
  </div>
);

export default MarketingLayout;
